import { computed, Directive, inject, InjectionToken, Injector, Provider, Type } from '@angular/core';
import { productDetailComponentStores, ProductDetailsComponentStore } from 'products-data';
import { ItemComponentBase } from 'products-ui';

@Directive()
export abstract class CartItemHostComponentBase extends ItemComponentBase {
  private readonly _injector = inject(Injector);
  private readonly _itemTypeComponentsToken = computed(() => (this.productType() ? this._componentTokens[this.productType()!] : null));

  protected readonly itemTypeComponents = computed(() => {
    const token = this._itemTypeComponentsToken();
    if (!token) return [];
    const components = this._injector.get(token, []);
    const result = Array.isArray(components) ? components.filter((comp) => comp != null) : [];
    return result;
  });

  protected readonly typeComponentInjector = computed(() => {
    const providers: Provider[] = [...productDetailComponentStores.filter((store) => store !== ProductDetailsComponentStore)];
    return Injector.create({
      providers,
      parent: this._injector,
    });
  });

  protected readonly ready = computed(() => {
    return !!this.typeComponentInjector() && !!this.itemTypeComponents() && !this.loading();
  });

  constructor(private _componentTokens: { [key: string]: InjectionToken<Type<unknown>[]> }) {
    super();
  }
}
